
import locales from '../locales'

export function searchObj(search) {
  if (search) {
    const searchList = search.slice(1, search.length).split('&');
    const searchObj = {}
    searchList.forEach(item => {
      searchObj[item.split('=')[0]] = item.split('=')[1]
    })
    return searchObj
  } else {
    return {}
  }
};

// util.js

export function inputBlur() {
  let u = navigator.userAgent

  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

  if (isIOS) {
    setTimeout(() => {
      const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0

      window.scrollTo(0, Math.max(scrollHeight - 1, 0))

    }, 200)
  }
}

export const renderText = (text) => {
  const searchProps = searchObj(window.location.search);
  if(searchProps.lang){
      if(searchProps.lang === 'zh_cn'){
        return locales.zh[text] || text
      } else {
        return locales.en[text] || text
      }
  } else {
    return locales.zh[text] || text
  }
}